// var config = require('../../config');
import React from 'react';
// import Select from 'react-select';
import moment from 'moment';
// import { Client } from '../../Client';
import { Picker, Emoji } from 'emoji-mart'
import 'emoji-mart/css/emoji-mart.css'

// var transform = require('../../lib/transform');

// import 'bootstrap-daterangepicker/daterangepicker.css';
// import DatetimeRangePicker from 'react-bootstrap-datetimerangepicker';


class AddAppointment extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			fields: {
				emoji: null,
				id: this.props.id || null,
				contact_id: this.props.contact_id || null,
				title: this.props.title || '',
				start_date: moment(this.props.start_date) || moment(),
				end_date: moment(this.props.end_date) || moment(this.props.start_date).add(1, 'hours'),
				appointment_type: this.props.appointment_type || '',
				description: this.props.description || '',
				location: this.props.location || '',
				label: this.props.label || '',
				reminder: this.props.reminder || '',
				reminder_date: this.props.reminder_date || '',
			},
		    fieldErrors: {},
		    contacts_options: [],
		};
	}


	componentDidMount() {
	}


	handleSave = (e) => {
		e.preventDefault();
		const data = this.state.fields;
		if (this.props.onSubmit) this.props.onSubmit(data);
		if (this.props.onClose) this.props.onClose();
	};


	handleDelete = (e) => {
		e.preventDefault()
		if (this.props.onDelete) this.props.onDelete(this.props.id)
		if (this.props.onClose) this.props.onClose();
	};

	handleClose = (e) => {
		e.preventDefault()
		if (this.props.onClose) this.props.onClose()
	};

	handleFieldChange = (e) => {
		const fields = this.state.fields;
		fields[e.target.name] = e.target.value;
		this.setState({ fields });
	};


	handleEmojiChange = (e) => {
		const fields = this.state.fields;
		fields['emoji'] = e.id;
		this.setState({ fields });
	};




	handleContactChange = (e) => {
		const fields = this.state.fields;
		if (e) fields['contact_id'] = e.value;
		else fields['contact_id'] = '';
		this.setState({ fields });		
	};

	handleDRPickerEvent = (event, picker) => {
		const fields = this.state.fields;
		fields['start_date'] = picker.startDate;
		fields['end_date'] = picker.endDate;
		this.setState({ fields });
	};

	handleSelectChange = (fieldName) => {
		return function(newValue) {
			// console.log(newValue);
			if (newValue == null) newValue = '';
			this.setState(Object.assign(this.state.fields, {
				[fieldName] : newValue.value
			}));	
		}.bind(this)
	};

	render() {
		// console.log(this.state.fields)
	    const titleText = this.state.fields.id ? 'Edit' : 'Add';
		const submitText = this.state.fields.id ? 'Save' : 'This one!';
		const btnDelete = this.state.fields.id ? <button className="btn  btn-secondary pull-right" onClick={this.handleDelete}><i className="fa fa-trash-o"></i> Delete</button> : '';
		// const labelStart = this.state.fields.start_date.format('DD/MM/YYYY hh:00 A');
		// const labelEnd = this.state.fields.end_date.format('DD/MM/YYYY hh:00 A');
		// const label = labelStart + ' - ' + labelEnd;

		return (
			<div id="modal-add" className="modal">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">{titleText} Emoji</h5>
						<button type="button" className="close" onClick={this.handleClose}>
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

	  				<div className="modal-body">
						<form>
							<div className="row">
								<div className="col-md-6 offset-md-3 text-center">

									<div className="text-center">
										<Emoji emoji={{id: this.state.fields.emoji, skin: 1}} size={64} set="facebook"/>
									</div>

									<Picker name="emoji" title="" showPreview={false} set="facebook" include={'people'} skin={1} onClick={ (emoji)=> this.handleEmojiChange(emoji) } />
								</div>
							</div>

							<div className="footer text-center" style={{marginTop: 30 + "px"}}>
								<button className="btn btn-primary" onClick={this.handleSave}>{submitText}</button>
								<button className="btn btn-secondary" onClick={this.handleClose}>Forget it</button>
								{ btnDelete }
							</div>

						</form>
					</div>
				</div>
			</div>

		);
	}
}




export default AddAppointment;




// WEBPACK FOOTER //
// ./src/js/components/Appointments/AddAppointment.js